export const profile = '/profile'
export const recentPosts = '/posts'
export const searchPosts = '/search/posts/'
export const searchUsers = '/search/users/'
export const favorites = '/favorites'
export const following = '/following'
export const likeds = '/likeds'
export const createPost = '/create'
export const updatePost = '/update'
export const auth = '/auth'

export const userRoute = '/user'

export const search = '/search'

